<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      use-self-complete-feedback
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import emApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesStoolPrApplicationRecordTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emApiMixin],
    data() {
        return {
            data: "",
            approve: "",
            itemType: "",
            purchasingType: "",
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        indirectPurchasingFields() {
            return [
                {
                    key: 'department',
                    label: '使用部门'
                },
                {
                    key: 'projectNo',
                    label: '项目号'
                },
                {
                    key: 'wbsNo',
                    label: '成本中心/WBS'
                },
                {
                    key: 'glAccountNo',
                    label: 'GL号'
                },
                {
                    key: 'fixedAssetNo',
                    label: '固资号/再建工程'
                },
                {
                    key: 'name',
                    label: '物品名称'
                },
                {
                    key: 'specification',
                    label: '规格'
                },
                {
                    key: 'quantity',
                    label: '数量',
                },
                {
                    key: 'unit',
                    label: '单位'
                },
                {
                    key:'expectDeliveryDate',
                    type: this.VALUE_TYPE.DATE,
                    label: '期望到货日期'
                },
                {
                    key: 'buyer',
                    label: '采购员'
                },
                {
                    key: 'newToolFlag',
                    label: '是否新工具',
                    type: this.VALUE_TYPE.SELECT,
                    options: [
                        {value: true, text: '是'},
                        {value: false, text: '否'}
                    ],
                },
                {
                    key: 'buyReason',
                    label: '购买原因'
                },
                {
                    key: 'oldToolFlag',
                    label: '是否旧工具',
                    type: this.VALUE_TYPE.SELECT,
                    options: [
                        {value: true, text: '是'},
                        {value: false, text: '否'}
                    ],
                },
                {
                    key: 'oldToolDestination',
                    label: '旧工具去向'
                },
                {
                    key: 'remark',
                    label: '备注',
                    type: this.VALUE_TYPE.TEXTAREA,
                },
            ];
        },
        shippingFields() {
            return [
                {
                    key: 'projectNo',
                    label: '项目号'
                },
                {
                    key: 'wbsNo',
                    label: 'WBS号'
                },
                {
                    key: 'glAccountNo',
                    label: 'GL号'
                },
                {
                    key: 'materialNo',
                    label: '物料号'
                },
                {
                    key: 'materialDesc',
                    label: '物料描述'
                },
                {
                    key: 'quantity',
                    label: '数量',
                    format: 'number'
                },
                {
                    key: 'deliveryData',
                    type: this.VALUE_TYPE.DATE,
                    label: '交货期'
                },
                {
                    key: 'consigneeAddress',
                    label: '收货地点'
                },
                {
                    key: 'buyer',
                    label: '采购员'
                },
                {
                    key: 'remark',
                    label: '备注',
                    type: this.VALUE_TYPE.TEXTAREA,
                },
            ];
        },
        config() {
            return {
                viewInfos: [
                    {
                        title: '直接采购物品明细',
                        entityName: 'sithMesStoolPrApplicationShippingDetail',
                        data: {
                            applicationNoFilter: this.$_emWorkflowTaskMixin_applicationNo,
                        }
                    },
                    {
                        title: '间接采购物品明细',
                        entityName: 'sithMesStoolPrApplicationIndirectPurchaseDetail',
                        data: {
                            applicationNoFilter: this.$_emWorkflowTaskMixin_applicationNo,
                        }
                    },
                ],
                defaultAssignee: true,
                'task_pr_apply_init': {
                    tag: {},
                    name: '创建pr申请',
                    withAttachment: true,
                    variables: [
                        {
                            label: '流程管理',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            initValue: 1,
                            options: [
                                {value: 1, text: '发起流程'},
                                {value: 0, text: '流程结束'}
                            ],
                            changeTag: val => {
                                return this.buildTag('notClose', val === 1);
                            }
                        },
                        {
                            needTag: 'notClose',
                            label: '预算',
                            name: 'budget',
                            format: 'number',
                            require:true,
                            saveTo: this.SAVE_TO.DATABASE,
                            type: this.VALUE_TYPE.INPUT,
                            initData: true,
                            changeTag: val => {
                                return this.buildTag('budget', val === 1);
                            }
                        },
                        {
                            needTag: 'notClose',
                            label: '是否有预算',
                            name: 'budgetEnoughFlag',
                            saveTo: this.SAVE_TO.FLOW,
                            initValue: true,
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: true, text: '是'},
                                {value: false, text: '否'}
                            ],
                        },
                        {
                            needTag: 'notClose',
                            label: '询价金额',
                            name: 'askPrice',
                            format: 'number',
                            saveTo: this.SAVE_TO.FLOW,
                            type: this.VALUE_TYPE.INPUT,
                        },
                        {
                            needTag: 'notClose',
                            label: '直接采购物品明细',
                            name: 'shippingDetailInfo',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.shippingFields,
                            entityName: 'sithMesStoolPrApplicationShippingDetail',
                            filterHolder: {
                                applicationNoFilter: this.$_emWorkflowTaskMixin_applicationNo,
                            },
                            saveHolder: {
                                applicationNo: this.$_emWorkflowTaskMixin_applicationNo,
                            }
                        },
                        {
                            label: '间接采购物品明细',
                            name: 'indirectPurchaseDetailInfo',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.indirectPurchasingFields,
                            entityName: 'sithMesStoolPrApplicationIndirectPurchaseDetail',
                            filterHolder: {
                                applicationNoFilter: this.$_emWorkflowTaskMixin_applicationNo,
                            },
                            saveHolder: {
                                applicationNo: this.$_emWorkflowTaskMixin_applicationNo,
                            }
                        },
                    ],
                    setApproveByBusinessData: (businessData, approve) => {
                        if (approve === 0) {
                            return 0;
                        } else if ((businessData['purchasingType'] === '间接采购' || businessData['itemType'] === '库存需求') && approve === 1) {
                            if (this.taskLocalVariables.hasOwnProperty('preApprove') && this.taskLocalVariables.preApprove) {
                                console.log("this.taskLocalVariables",this.taskLocalVariables.preApprove)
                                switch (this.taskLocalVariables.preApprove) {
                                    case 'task_department_manager_confirm':
                                        return 2;
                                    case 'task_BA_manager_confirm':
                                        return 21;
                                    case 'task_CEO_confirm':
                                        return 22;
                                    case 'task_CFO_confirm':
                                        return 23;
                                    case 'task_special_people_confirm':
                                        return 24;
                                }
                            } else {
                                return 2;
                            }
                        } else if (businessData['purchasingType'] === '直接采购' && approve === 1) {
                            if (this.taskLocalVariables.hasOwnProperty('preApprove') && this.taskLocalVariables.preApprove) {
                                switch (this.taskLocalVariables.preApprove) {
                                    case 'task_PM_head_confirm':
                                        return 1;
                                    case 'task_CPM_head_confirm':
                                        return 12;
                                }
                            } else {
                                return 1;
                            }
                        }
                        return approve;
                    },
                    //把budgetChangeFlag放进变量中
                    addVariableByApprove: approve => {
                        if (approve === 1 || approve === 2) {
                            return {name: 'budgetChangeFlag', value: true};
                        } else {
                            return {name: 'budgetChangeFlag', value: false};
                        }
                    },
                    setApproveByVariable: [
                        {
                            // 预算变更的话，从头开始
                            variableName: 'budget',
                            handler: (approve, val) => {
                                if (val!== this.$_emWorkflowTaskMixin_businessData.budget)  {
                                    console.log("budgetChangeFlag",val, this.$_emWorkflowTaskMixin_businessData.budget)
                                    switch (approve) {
                                        //cpm拒绝了，ba从头审批
                                        case 12:
                                            return 1;
                                        //ba，特殊人员，ceo,cfo节点拒绝了，从头审批
                                        case 21:
                                        case 22:
                                        case 23:
                                        case 24:
                                            return 2;
                                    }
                                }
                                return approve;
                            }
                        },
                    ],
                    approveToNextTask: {
                        0: 'happy-end',
                        1: 'task_PM_head_confirm',
                        12: 'task_CPM_head_confirm',
                        2: 'task_department_manager_confirm',
                        21: 'task_BA_manager_confirm',
                        22: 'task_CEO_confirm',
                        23: 'task_CFO_confirm',
                        24: 'task_special_people_confirm',
                    },
                    defaultAssignee: true
                },
                'task_PM_head_confirm': {
                    name: 'PM经理确认',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_PM_head_confirm'}
                        }
                    },
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_CPM_head_confirm',
                    },
                    defaultAssignee: true,
                },
                'task_department_manager_confirm': {
                    name: '部门经理审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    withComment: true,
                    setApproveByBusinessData: (businessData, approve) => {
                        if (approve === 1) {
                            if (businessData['purchasingType'] === '直接采购') {
                                if (businessData['itemType'] === '库存需求') {
                                    if (this.taskLocalVariables.hasOwnProperty('budget') && this.taskLocalVariables.budget > 50000) {
                                            return 4;
                                    }
                                    return 1
                                }
                                return 1
                            }else if (businessData['purchasingType'] === '间接采购' && businessData['itemType'] === '人事') {
                                return 3
                            } else {
                                return 2
                            }
                        } else if (approve === 0){
                            return 0
                        } else {
                            return approve;
                        }
                    },
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_department_manager_confirm'}
                        }
                    },
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_BA_manager_confirm',
                        2: 'task_BA_confirm',
                        3: 'task_special_people_confirm',
                        4: 'task_CFO_confirm',
                    },
                    defaultAssignee: true,
                },
                'task_CPM_head_confirm': {
                    name: 'CPM审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    setApproveByBusinessData: (businessData, approve) => {
                        if (approve === 1) {
                            if (businessData['itemType'] === '项目补料') {
                                return  2
                            } else if (businessData['purchasingType'] === '现场服务') {
                                return  1
                            }
                        }
                        return approve;

                    },
                    addVariableByApprove: approve => {
                        if (approve === 0) {
                            return {name: 'preApprove', value: 'task_CPM_head_confirm'}
                        }
                    },
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_do_manually_hook_up_confirm',
                        2: 'task_tc_contact_confirm'
                    },

                    defaultAssignee: true,
                },
                'task_special_people_confirm': {
                    name: '特殊人员填写信息',
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_BA_confirm',
                    },
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_special_people_confirm'}
                        }
                    },
                    defaultAssignee: true,
                },
                'task_BA_confirm': {
                    name: 'BA提供关键信息',
                    variables: [
                        {
                            label: 'GL Account',
                            name:  'GL_ACCOUNT',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            label: '固资号/再建工程',
                            name: 'FIXED_ASSET_NO',
                            saveTo: this.SAVE_TO.FLOW,
                            type: this.VALUE_TYPE.INPUT,

                        },
                    ],
                    withComment: true,
                    //根据预算类型，走不同的流程
                    setApproveByBusinessData: bussinessData => {
                        console.log("this.taskLocalVariables.budget", this.taskLocalVariables.budget)
                        if (this.taskLocalVariables.hasOwnProperty('budget')) {
                            if (this.taskLocalVariables.budget > 50000) {
                                return 2;
                            } else {
                                return 1;
                            }
                        }
                    },
                    approveToNextTask: {
                        1: 'task_BA_manager_confirm',
                        2: 'task_CFO_confirm',
                    },
                    defaultAssignee: true,
                },
                'task_BA_manager_confirm': {
                    name: 'BA经理审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_do_manually_hook_up_confirm',
                        2: 'task_cost_center_assistant_confirm'
                    },
                    setApproveByBusinessData:(businessData, approve) => {
                        if (approve === 1) {
                            //如果是库存需求走do
                            if (businessData['itemType'] === '库存需求') {
                                return  1
                            } else {
                                return 2
                            }
                        } else if (approve === 0) {
                            return  0
                        } else {
                            return approve;
                        }
                    },
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_BA_manager_confirm'}
                        }
                    },
                    defaultAssignee: true,
                },
                'task_CFO_confirm': {
                    name: 'CFO审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    setApproveByBusinessData:(businessData, approve) => {
                        if (approve === 1) {
                            //如果是库存需求走do
                            if (businessData['itemType'] === '库存需求') {
                                return  21
                            } else {
                                return  1
                            }
                        } else if (approve === 0) {
                            return  0
                        }
                    },
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_CFO_confirm'}
                        }
                    },
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_CEO_confirm',
                        21: 'task_do_manually_hook_up_confirm',
                    },
                    defaultAssignee: true,
                },
                'task_CEO_confirm': {
                    name: 'CEO审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 0, text: '否'},
                        ]
                    }],
                    withComment: true,
                    approveToNextTask: {
                        0: 'task_pr_apply_init',
                        1: 'task_cost_center_assistant_confirm',
                    },
                    addVariableByApprove: approve => {
                        if ( approve === 0) {
                            return {name: 'preApprove', value: 'task_CEO_confirm'}
                        }
                    },
                    defaultAssignee: true,
                },
                'task_cost_center_assistant_confirm': {
                    name: 'cost center助理确认ariba是否填写',
                    withComment: true,
                    approveToNextTask: {
                        1: 'happy-end',
                    },
                    setApproveBeforeSubmit: approve => {
                        return 1;
                    },
                    defaultAssignee: true,
                },
                'task_tc_contact_confirm': {
                    name: 'TC联系人确认',
                    withComment: true,
                    withAttachment: true,
                    setApproveBeforeSubmit: approve => {
                        return 1;
                    },
                    approveToNextTask: {
                        1: 'task_do_manually_hook_up_confirm',
                    },
                    defaultAssignee: true,
                },
                'task_do_manually_hook_up_confirm': {
                    name: 'DO确认手动上挂',
                    withComment: true,
                    withAttachment: true,
                    setApproveBeforeSubmit: approve => {
                        return 1;
                    },
                    approveToNextTask: {
                        1: 'happy-end',
                    },
                    defaultAssignee: true,
                },
                'happy-end': {
                    name: '结束',
                    isOver: true
                }
            }
        }
    },
}
;
</script>
